export default __webpack_public_path__ + "static/media/pills.afc33ad1.png";